const VehicleStatus = {
  Active: "active",
  Inactive: "inactive",
};

export default VehicleStatus;
